import {
  FetchFileAttachmentsFilters,
  FetchFileAttachmentsSort,
  FetchFileAttachmentsLimit,
  FetchFileAttachmentsGqlQuery,
  FetchFileAttachmentsCacheKey
} from '../../fileAttachmentsTypes';

import {
  ReadInfiniteIndexQueryBaseNodeType,
  useReadInfiniteIndexQuery
} from '../../../common/reactQuery/hooks/useReadInfiniteIndexQuery';

import {
  INITIAL_FILE_ATTACHMENTS_FILTERS,
  INITIAL_FILE_ATTACHMENTS_LIMIT,
  INITIAL_FILE_ATTACHMENTS_SORT
} from '../../fileAttachmentsConstants';

interface FileAttachmentsOptions {
  cacheKey: FetchFileAttachmentsCacheKey;
  query: FetchFileAttachmentsGqlQuery;
  initialFilters?: FetchFileAttachmentsFilters;
  initialSort?: FetchFileAttachmentsSort;
  initialLimit?: FetchFileAttachmentsLimit;
  options?: {
    cacheTime?: number;
    staleTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
  };
}

const scope = 'fileAttachments';

function useFileAttachments<
  FileAttachmentItemType extends ReadInfiniteIndexQueryBaseNodeType
>({
  cacheKey,
  query,
  initialFilters = INITIAL_FILE_ATTACHMENTS_FILTERS,
  initialSort = INITIAL_FILE_ATTACHMENTS_SORT,
  initialLimit = INITIAL_FILE_ATTACHMENTS_LIMIT,
  options = {}
}: FileAttachmentsOptions) {
  const {
    data,
    items,
    itemsError,
    itemsTotalCount,
    isFetched,
    isLoading,
    isFetchingNextPage,
    isPlaceholderData,
    changeItemsFilters,
    currentPage,
    currentLimit,
    currentFilters,
    currentSort,
    hasNextPage,
    updateItemCache,
    loadMoreItems,
    clearItemsFilters,
    filterItems,
    sortItems,
    limitItems
  } = useReadInfiniteIndexQuery<FileAttachmentItemType>({
    cacheKey,
    initialFilters,
    initialLimit,
    initialSort,
    options,
    query,
    scope
  });

  return {
    fileAttachmentsData: data,
    fileAttachments: items,
    fileAttachmentsError: itemsError,
    fileAttachmentsTotalCount: itemsTotalCount,
    fileAttachmentsFetched: isFetched,
    fileAttachmentsLoading: isLoading,
    fileAttachmentsFetchingNextPage: isFetchingNextPage,
    fileAttachmentsIsPlaceholderData: isPlaceholderData,
    fileAttachmentsFilters: currentFilters,
    fileAttachmentsSort: currentSort,
    fileAttachmentsPage: currentPage,
    fileAttachmentsLimit: currentLimit,
    hasNextFileAttachmentsPage: hasNextPage,
    updateFileAttachmentCache: updateItemCache,
    loadMoreFileAttachments: loadMoreItems,
    filterFileAttachments: filterItems,
    clearFileAttachmentsFilters: clearItemsFilters,
    sortFileAttachments: sortItems,
    limitFileAttachments: limitItems,
    changeFileAttachmentsFilters: changeItemsFilters
  };
}

export default useFileAttachments;
